import { faCloudArrowUp, faEye, faPalletBoxes, faTruck, faBroom, faUsers, faIndustryWindows, faClipboardList, faPalletBox, faJugBottle, faConveyorBeltBoxes, faBlender, faPenRuler, faRepeat, faRadiation, faPickaxe, faFlaskVial, faShapes, faCalendar } from '@fortawesome/pro-duotone-svg-icons';
import { Role } from './roles.constants';


export const HOME_BOXES: any = [{
    section: 'Planificación',
    boxes: [{
      name: 'Carga planning',
      icon: faCloudArrowUp,
      routerLink: '/upload-apo',
      swapOpacity: true,
      roles: [Role.Admin, Role.Planificador]
    }, 
    {
      name: 'Consulta planning',
      icon: faEye,
      swapOpacity: true,
      routerLink: '/view-apo',
      roles: [Role.Admin, Role.Planificador]
    }]
  }, 
  {
    section: 'Datos maestros',
    boxes: [{
      name: 'Productos',
      routerLink: '/products',

      icon: faClipboardList,
      swapOpacity: true,
      roles: [Role.Admin]
    }, 
    {
      name: 'Limpieza',
      routerLink: '/cleaning',
      icon: faBroom,
      swapOpacity: false,
      roles: [Role.Admin]
    },
    {
      name: 'Matriz de limpieza',
      routerLink: '/cleaning-rules',
      icon: faPenRuler,
      swapOpacity: false,
      roles: [Role.Admin]
    }, 
    {
      name: 'Blenders',
      routerLink: '/blenders',
      icon: faBlender,
      swapOpacity: false,
      roles: [Role.Admin]
    },
    {
      name: 'Envases',
      routerLink: '/packages',
      icon: faJugBottle,
      swapOpacity: false,
      roles: [Role.Admin]
    },
    {
      name: 'Envasadoras',
      routerLink: '/packaging-machines',
      icon: faConveyorBeltBoxes,
      swapOpacity: true,
      roles: [Role.Admin]
    },
    {
      name: 'Materias primas',
      routerLink: '/mmpp-products',
      icon: faPickaxe,
      swapOpacity: false,
      roles: [Role.Admin]
    },
    {
      name: 'Materiales',
      routerLink: '/materials',
      icon: faFlaskVial,
      swapOpacity: false,
      roles: [Role.Admin]
    },
    {
      name: 'Producto - Mixtion',
      routerLink: '/product-mixtion',
      icon: faShapes,
      swapOpacity: false,
      roles: [Role.Admin]
    },]
  },
  {
    section: 'Administración',
    boxes: [{
      name: 'Usuarios',
      routerLink: '/users',
      icon: faUsers,
      swapOpacity: false,
      roles: [Role.Admin]
    },
    {
      name: 'Procesos automáticos',
      routerLink: '/jobs',
      icon: faRepeat,
      roles: [Role.Admin]
    },
    {
      name: 'Calendario',
      routerLink: '/calendar',
      icon: faCalendar,
      swapOpacity: false,
      roles: [Role.Admin]
    }
   ]
  }];

  export const ROLES = [
    {
      key: 'admin',
      value: 'Admin'
    },
    {
      key: 'calidad',
      value: 'Calidad'
    },
    {
      key: 'envasado',
      value: 'Envasado'
    },
    {
      key: 'jefe_turno',
      value: 'Jefe de turno'
    },
    {
      key: 'logistico',
      value: 'Logístico'
    },
    {
      key: 'mizu',
      value: 'Mizu'
    },
    {
      key: 'planificador',
      value: 'Planificador'
    },
    {
      key: 'preparacion',
      value: 'Preparación'
    },
  ];
  